export default "__VITE_ASSET__074e7fd6__"